import { render, staticRenderFns } from "./StatesForEntity.vue?vue&type=template&id=afec77dc&scoped=true&"
import script from "./StatesForEntity.vue?vue&type=script&lang=js&"
export * from "./StatesForEntity.vue?vue&type=script&lang=js&"
import style0 from "./StatesForEntity.vue?vue&type=style&index=0&id=afec77dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afec77dc",
  null
  
)

export default component.exports